import React from 'react';
import {useRecordHotkeys} from 'react-hotkeys-hook';
import {mapShortcut} from 'services/shortcuts';
import {TextField} from 'components/fields';

type Props = {
  name: string;
  label: string;
  onChange: (value: Set<string>) => void;
  currentShortcut: string;
  readonly?: boolean;
};
export const KeyRecordInput: React.FC<Props> = ({
  readonly,
  name,
  label,
  onChange,
  currentShortcut,
}) => {
  const [keys, {start, stop}] = useRecordHotkeys();

  return (
    <TextField
      name={name}
      type={'text'}
      label={label}
      readonly={readonly}
      onFocus={() => {
        start();
      }}
      onKeyDown={e => {
        if (e.key === 'Tab' || e.key === 'Escape') {
          stop();
        } else if (e.key === 'Backspace' || e.key === 'Delete') {
          e.preventDefault();
          onChange(new Set());
          stop();
        }
      }}
      onBlur={() => {
        stop();
        if (keys.size > 0 && mapShortcut(keys) !== currentShortcut) {
          onChange(keys);
        }
      }}
      value={keys.size > 0 ? mapShortcut(keys) : currentShortcut}
    />
  );
};
